module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="well" style="font-size: 12px;">\r\n    <div class="form form-inline">\r\n        <div class="form-group">\r\n            <label class="control-label" for="org-name-from">Org name: </label>\r\n            <select id="org-name-from" name="orgNameFrom" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\r\n                ';
 if (ucc == orgNameFrom) { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } else { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } 
__p+='\r\n                ';
 }) 
__p+='\r\n            </select>\r\n            <label class="control-label" for="org-name-to">-</label>\r\n            <select id="org-name-to" name="orgNameTo" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\r\n                ';
 if (ucc == orgNameTo) { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } else { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } 
__p+='\r\n                ';
 }) 
__p+='\r\n            </select>\r\n            <label class="control-label" for="md-name-from" style="margin-left: 20px;">MD name: </label>\r\n            <select id="md-name-from" name="mdNameFrom" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\r\n                ';
 if (ucc == mdNameFrom) { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } else { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } 
__p+='\r\n                ';
 }) 
__p+='\r\n            </select>\r\n            <label class="control-label" for="md-name-to">-</label>\r\n            <select id="md-name-to" name="mdNameTo" class="form-control input-sm filter-field" style="width:auto;">\r\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\r\n                ';
 if (ucc == mdNameTo) { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } else { 
__p+='\r\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\r\n                ';
 } 
__p+='\r\n                ';
 }) 
__p+='\r\n            </select>\r\n            <label class="control-label" for="contact-value" style="margin-left: 20px;">Contact Value: </label>\r\n            <input type="text" class="form-control contact-value-input" id="contact-value" name="contactValue" style="min-width: 260px !important;"\r\n                   placeholder="Type at least 3 characters and Press Enter" value="'+
((__t=( contactValue ))==null?'':__t)+
'"/>\r\n        </div>\r\n    </div>\r\n\r\n    <div class="btn-group" id="sending-method" style="display: list-item; margin-left: auto; margin-right: auto; width: 60%;">\r\n        ';
 _.each(_.keys(sendingMethods), function(method){ 
__p+='\r\n        <a class="btn btn-primary btn-sm '+
((__t=( sendingMethodsState[method] ))==null?'':__t)+
'" data-title="'+
((__t=( method ))==null?'':__t)+
'">'+
((__t=( sendingMethods[method] ))==null?'':__t)+
'</a>\r\n        ';
 }) 
__p+='\r\n    </div>\r\n\r\n</div>\r\n<hr>\r\n<div class="col-md-12 col-xs-12 row bold">\r\n    <div class="col-md-3 col-xs-3 col-md-offset-2 col-xs-offset-2">\r\n        Total (by reviewer):\r\n    </div>\r\n    <div class="col-md-2 col-xs-2" id="signed-md-total"></div>\r\n    <div class="col-md-2 col-xs-2" id="pending-md-total"></div>\r\n</div>\r\n\r\n<div class="form form-horizontal" style="margin-left: 18px;">\r\n    <div class="col-md-12 col-xs-12 row stat-row">\r\n        <div class="col-md-5 col-xs-5 clickable sort-header\r\n            ';
 if (activeSort == 'title' && sortDirection == 'asc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
 } else if (activeSort == 'title' && sortDirection == 'desc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
 } 
__p+='"\r\n             id="title" title="Sort"> Organization</div>\r\n        <div class="col-md-2 col-xs-2 clickable sort-header\r\n            ';
 if (activeSort == 'signed' && sortDirection == 'asc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
 } else if (activeSort == 'signed' && sortDirection == 'desc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
 } 
__p+='"\r\n             id="signed" title="Sort"> Signed</div>\r\n        <div class="col-md-2 col-xs-2 clickable sort-header\r\n            ';
 if (activeSort == 'pending' && sortDirection == 'asc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-top\r\n                ';
 } else if (activeSort == 'pending' && sortDirection == 'desc') { 
__p+=' active-sort-header glyphicon glyphicon-triangle-bottom ';
 } 
__p+='"\r\n             id="pending" title="Sort"> Pending</div>\r\n        <div class="col-md-3 col-xs-3">Preferred Contact Method</div>\r\n    </div>\r\n\r\n    ';
 _.each(orgperson, function(node, index) { 
__p+='\r\n    <div class="col-md-12 col-xs-12 row stat-row">\r\n        <div class="col-md-5 col-xs-5">\r\n            <b><a href="/#organization/'+
((__t=( node.id ))==null?'':__t)+
'"  target="_blank">'+
((__t=( node.title ))==null?'':__t)+
'</a></b>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            ';
 if (node.id ==='null'){ 
__p+='\r\n            '+
((__t=( node.signed ))==null?'':__t)+
'\r\n            ';
 } else { 
__p+='\r\n            <a href="'+
((__t=( orgSignedDocumentsLink(node.id) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( node.signed ))==null?'':__t)+
'</a>\r\n            ';
 } 
__p+='\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            ';
 if (node.id ==='null'){ 
__p+='\r\n            '+
((__t=( node.pending ))==null?'':__t)+
'\r\n            ';
 } else { 
__p+='\r\n            <a href="'+
((__t=( orgPendingDocumentsLink(node.id) ))==null?'':__t)+
'" target="_blank">'+
((__t=( node.pending ))==null?'':__t)+
'</a>\r\n            ';
 } 
__p+='\r\n        </div>\r\n        <div class="col-md-3 col-xs-3">\r\n            ';
 (transformSendingMethods(node.sendingMethods) || []).forEach(function(method){ 
__p+='\r\n            <span class="badge badge-info">\r\n                ';
 if (method.methodName === 'EMAIL') { 
__p+=' <span title="Email"><span class="glyphicon glyphicon-envelope tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'EMAIL') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else  if (method.methodName === 'FAX') {  
__p+=' <span title="Fax"><span class="glyphicon glyphicon-print tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'FAX') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else  if (method.methodName === 'PHONE'){ 
__p+=' <span title="Phone"><span class="glyphicon glyphicon-earphone tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'PHONE') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'REVIEW_AND_SIGN') {  
__p+=' <span title="Review and sign"><span class="glyphicon glyphicon-home tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'REVIEW_AND_SIGN') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'HAND_DELIVERY') { 
__p+=' <span title="Hand Delivery"><span class="glyphicon glyphicon-hd-video tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'HAND_DELIVERY') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'MEDICITY') {  
__p+=' <span title="Direct Messaging"><span class="tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(node.contacts, 'MEDICITY') || []).join(',\n') ))==null?'':__t)+
'">XDR</span></span>\r\n                ';
 } else { 
__p+=' <span>'+
((__t=( method.methodName ))==null?'':__t)+
'</span> ';
 } 
__p+='\r\n                '+
((__t=( method.count ))==null?'':__t)+
'\r\n            </span>\r\n            ';
 }) 
__p+='\r\n        </div>\r\n    </div>\r\n\r\n    ';
 _.each(node.personsList, function(personStat, index) { 
__p+='\r\n    <div class="col-md-12 col-xs-12 row person-stat-row">\r\n        <div class="col-md-4 col-xs-4 col-md-offset-1 col-xs-offset-1">\r\n            ';
 if (personStat.duplicated) { 
__p+='\r\n            <span class="glyphicon glyphicon-duplicate duplicate-icon" title="Appears in another organization"></span>\r\n            ';
 } 
__p+='\r\n            <a href="/#person/'+
((__t=( personStat.id ))==null?'':__t)+
'"  target="_blank">'+
((__t=( personStat.title ))==null?'':__t)+
'</a>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            <a href="'+
((__t=( personSignedDocumentsLink(node.id, personStat.id) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( personStat.signed ))==null?'':__t)+
'</a>\r\n        </div>\r\n        <div class="col-md-2 col-xs-2">\r\n            <a href="'+
((__t=( personPendingDocumentsLink(node.id, personStat.id) ))==null?'':__t)+
'" target="_blank">'+
((__t=( personStat.pending ))==null?'':__t)+
'</a>\r\n        </div>\r\n        <div class="col-md-3 col-xs-3">\r\n            ';
 (transformSendingMethods(personStat.sendingMethods) || []).forEach(function(method){ 
__p+='\r\n            <span class="badge badge-info">\r\n                ';
 if (method.methodName === 'EMAIL') { 
__p+=' <span title="Email"><span class="glyphicon glyphicon-envelope tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'EMAIL') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else  if (method.methodName === 'FAX') {  
__p+=' <span title="Fax"><span class="glyphicon glyphicon-print tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'FAX') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else  if (method.methodName === 'PHONE'){ 
__p+=' <span title="Phone"><span class="glyphicon glyphicon-earphone tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'PHONE') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'REVIEW_AND_SIGN') {  
__p+=' <span title="Review and sign"><span class="glyphicon glyphicon-home tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'REVIEW_AND_SIGN') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'HAND_DELIVERY') { 
__p+=' <span title="Hand Delivery"><span class="glyphicon glyphicon-hd-video tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'HAND_DELIVERY') || []).join(',\n') ))==null?'':__t)+
'"></span></span>\r\n                ';
 } else if (method.methodName === 'MEDICITY') {  
__p+=' <span title="Direct Messaging"><span class="tooltipped-stat-contact contact-popover" role="button" data-toggle="popover" data-content="'+
((__t=( (getContacts(personStat.contacts, 'MEDICITY') || []).join(',\n') ))==null?'':__t)+
'">XDR</span></span>\r\n                ';
 } else { 
__p+=' <span>'+
((__t=( method.methodName ))==null?'':__t)+
'</span> ';
 } 
__p+='\r\n                '+
((__t=( method.count ))==null?'':__t)+
'\r\n            </span>\r\n            ';
 }) 
__p+='\r\n        </div>\r\n    </div>\r\n    ';
 }) 
__p+='\r\n    ';
 }) 
__p+='\r\n\r\n\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/statistics/documents-statistics-view.html
// module id = 304
// module chunks = 0